module.exports = __webpack_public_path__ + "img/zh_ad.c2714556.jpg";